import { COLORS } from '../../config/designSystem/Colors';
import { FC, PropsWithChildren } from 'react';
import { View } from 'react-native';
import { useSystemBottomInset } from '../../hooks/ui/useSystemBottomInset';

/**
 * Ends the app's layout where the Android system navigation bar begins.
 *
 * Since the Expo SDK 54 hop the Android build is edge-to-edge, so the app window spans
 * the whole screen instead of stopping above the navigation bar. Every screen written
 * before that assumed the window ended there, so anything at the bottom -- the tab bar,
 * a screen's CTA, the last row of a list -- was drawn underneath the navigation bar,
 * clipped and untappable.
 *
 * Reserving the inset once here restores that assumption for the entire app, which is
 * why individual screens do NOT add it themselves. The one exception is content in a
 * native <Modal>: that renders in its own window, outside this view, so a bottom sheet
 * still has to inset itself (see BasicModalBelowWrapper).
 *
 * No-op on iOS and web -- `useSystemBottomInset` returns 0 there.
 */
export const AndroidSystemBarInset: FC<PropsWithChildren> = ({ children }) => {
  const systemBottomInset = useSystemBottomInset();

  return (
    <View style={{ flex: 1, paddingBottom: systemBottomInset, backgroundColor: COLORS.surface.primary }}>
      {children}
    </View>
  );
};
